module.exports = __webpack_public_path__ + "static/img/botj.0f971df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/botj.png
// module id = +ncp
// module chunks = 93